import axios from 'axios';

export function sendPhoneNumber(phoneNumber: string, user_id: number) {
  return axios.post(`/api/users/${user_id}/phone_number`, {
    phoneNumber,
  });
}

export function sendVerificationCode(
  phoneNumber: string,
  code: string,
  user_id: number,
) {
  return axios.post(`/api/users/${user_id}/phone_number/confirm`, {
    phoneNumber,
    code,
  });
}

export async function signup(signupInfos: {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  position: string;
  jobTitle: string;
  firmSize: string;
  agreedToTerms: boolean;
}) {
  return (await axios.post('/api/users', signupInfos)).data;
}

export function validateAutomaticSignup({
  password,
  agreedToTerms,
  verificationToken,
  firstName,
  lastName,
}: {
  password: string;
  agreedToTerms: boolean;
  verificationToken: string;
  firstName: string;
  lastName: string;
}) {
  return axios.post('/organization/join', {
    password,
    agreedToTerms,
    verificationToken,
    firstName,
    lastName,
  });
}
